var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-loading',{attrs:{"is-full-page":true,"can-cancel":false},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}}),_vm._v(" "),_c('div',{ref:"turnstile",staticClass:"turnstile",attrs:{"data-sitekey":_vm.cloudflareSitekey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }